module.exports = __webpack_public_path__ + "static/media/close.cfbbdf30.svg";